import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { fetchWedding } from 'actions/WeddingActions';
import { getWeddingPreviewUrl } from 'selectors/website/websiteSelectors';
import { useResponsiveContext } from 'components/common/ResponsiveContext';
import { WebsiteTileActions } from './WebsiteTileActions';
import cardStyles from './CardTile.module.less';
import { Tag } from './Tag';
import styles from './WebsiteTile.module.less';

interface WebsiteTileProps {
  image: string;
  isSelected?: boolean;
  themeLabel?: string;
  hasWeddingAccount?: boolean;
}

export const WebsiteTile: React.FC<WebsiteTileProps> = ({
  image,
  isSelected,
  themeLabel,
  hasWeddingAccount,
}) => {
  const dispatch = useDispatch();
  const { isMobile } = useResponsiveContext();
  const previewSlug = useSelector(getWeddingPreviewUrl);

  useEffect(() => {
    if (hasWeddingAccount && isSelected) {
      dispatch(fetchWedding());
    }
  }, [hasWeddingAccount]);

  return (
    <div className={styles.websiteTile}>
      <div className={styles.image} style={{ backgroundImage: `url(${image})` }}>
        <WebsiteTileActions
          isSelected={isSelected}
          fullWebsiteUrl={previewSlug}
          themeLabel={themeLabel}
          isMobileView={isMobile}
        />
        {isSelected ? <Tag>Selected design</Tag> : null}
      </div>
      <div className={cardStyles.cardInfo}>
        <div className={cardStyles.cardName}>
          {isMobile ? 'Matching Website' : 'Matching Wedding Website'}
        </div>
        <div className={cardStyles.cardPrices}>Free</div>
      </div>
    </div>
  );
};
